import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router';

import BreadCrumbs from '../../../components/BreadCrumbs/BreadCrumbs';
import DeleteIcon from '../../../components/Icons/DeleteIcon';
import EditIcon from '../../../components/Icons/EditIcon';
import PageHeader from '../../../components/Layout/PageHeader';
import PageLayout from '../../../components/Layout/PageLayout';
import DeleteContactModal from '../../../components/Modal/ModalActions/DeleteContactModal/DeleteContactModal';
import UpdateContactModal from '../../../components/Modal/ModalActions/UpdateContactModal/UpdateContactModal';
import Page from '../../../components/Page/Page';
import Table from '../../../components/Table/Table';
import ActionRowWithModal from '../../../components/Table/TableAccessories/ActionRowWithModal';
import TripLogCell from '../../../components/Table/TableMobileRowCell/TripLogCell';
import { TRIP_LOG } from '../../../routes/routeConstants';

const TripLogAddressBook = () => {
  const [pathArr, setPathArr] = useState<Record<string, string>[]>([]);
  const { pathname } = useLocation();

  useEffect(() => {
    setPathArr(() => [
      {
        name: `Trip Log`,
        link: `/${TRIP_LOG}`,
      },
      {
        name: `Address Book`,
        link: pathname,
      },
    ]);
    // eslint-disable-next-line
  }, []);

  return (
    <Page title='Logirate | Address Book'>
      <PageLayout>
        <BreadCrumbs pathData={pathArr as any} />
        <PageHeader
          title='Address Book'
          className='borderless no-bottom-padding'
        />
        <Table
          tableHeader={{
            'Customer email': 'email',
            'Contact Info': 'name',
            'Total Trips Logged': 'totalTrips',
          }}
          // tableDataSourceUrl='api/v1/trip-logs'
          tableDataSourceUrl='api/v1/contacts'
          cellsCustomComp={{}}
          moreOptionsComponents={[
            <ActionRowWithModal
              key='Update Contact Info'
              label='Update Contact Info'
              width='255px'
              icon={<EditIcon />}
              modalCompFn={(data) => <UpdateContactModal data={data} />}
            />,
            <ActionRowWithModal
              key='Delete Contact'
              label='Delete Contact'
              color='#C93D06'
              width='255px'
              icon={<DeleteIcon />}
              modalCompFn={(data) => <DeleteContactModal data={data} />}
            />,
          ]}
          mobileCellComp={<TripLogCell />}
        />
      </PageLayout>
    </Page>
  );
};

export default TripLogAddressBook;
